<template>
    <div class="device-applications__wrapper">
        <div class="device-applications">
            <div class="device-applications__name">
                {{ $t("devices.compatibleApplications", [applications.length, device.name]) }}
            </div>
            <div class="device-applications__content">
                <application-thumb
                    v-for="application in applications"
                    :key="application.id"
                    :application="application"
                ></application-thumb>
            </div>
            <div class="device-applications__controls">
                <sah-button @click.prevent.native="$emit('close')">
                    {{ $tc("words.close") }}
                </sah-button>
            </div>
        </div>
    </div>
</template>

<script>
import {SahButton} from "atom";
import ApplicationThumb from "./ApplicationThumb.vue";

/**
 *
 * @vue-prop {Object} warehouse - warehouse
 */
export default {
    name: "device-applications",
    components: {
        ApplicationThumb,
        SahButton,
    },
    props: {
        applications: {type: Array, required: true},
        device: {type: Object, required: true},
    },
};
</script>

<style scoped lang="scss">
.device-applications__wrapper::v-deep {
    @apply fixed top-0 left-0 z-10 h-screen w-screen flex flex-row items-center justify-center;
    background-color: $background-wrapper-edit-color;

    .device-applications {
        @apply w-10/12 flex flex-col rounded;
        background-color: $background-application-color;
        font-size: $font-small;
        max-height: 90%;
    }

    .device-applications__name {
        @apply font-bold py-3 px-5;
        background-color: $background-card-header-color;
        color: $text-card-header-color;
    }

    .device-applications__content {
        @apply flex flex-wrap bg-white py-3 px-5 overflow-y-auto;
    }

    .device-applications__controls {
        @apply flex justify-end py-3 px-5 mt-4;
        background-color: $background-card-footer-color;
    }
}
</style>
